// extracted by mini-css-extract-plugin
export var addButton = "_gg-0";
export var border = "_gg-8";
export var check = "_gg-h";
export var danger = "_gg-6";
export var dropdownContainer = "_gg-1";
export var editModalBody = "_gg-j";
export var footerContainer = "_gg-i";
export var fullWidth = "_gg-a";
export var hide = "_gg-9";
export var icon = "_gg-3";
export var input = "_gg-7";
export var inputFlex = "_gg-b";
export var inputWrapper = "_gg-c";
export var manualFocus = "_gg-5";
export var optionButton = "_gg-4";
export var pillWrapper = "_gg-e";
export var pointer = "_gg-2";
export var showOverflow = "_gg-f";
export var tagsFlex = "_gg-d";
export var xButton = "_gg-g";